module.exports = __webpack_public_path__ + "img/dance-test-icon10.deedd330.png";